export default __webpack_public_path__ + "static/media/court-type.616cf279.svg";